interface RequestsByTierTableProps {
  requests: {
    tier1?: number;
    tier2?: number;
    tier3?: number;
    tier4?: number;
    tier5?: number;
  };
}

const RequestsByTierTable = ({ requests }: RequestsByTierTableProps) => {
  return (
    <table className="table-auto border">
      <tr className="border">
        <th className="border">Tier 1</th>
        <th className="border">Tier 2</th>
        <th className="border">Tier 3</th>
        <th className="border">Tier 4</th>
        <th className="border">Tier 5</th>
      </tr>
      <tr>
        <td className="border">{requests.tier1 || 0}</td>
        <td className="border">{requests.tier2 || 0}</td>
        <td className="border">{requests.tier3 || 0}</td>
        <td className="border">{requests.tier4 || 0}</td>
        <td className="border">{requests.tier5 || 0}</td>
      </tr>
    </table>
  );
};

export default RequestsByTierTable;
